import axios from "../../axios";

const addNewSetting = async ({ resource, resource_tab, settings_level = "system", data: dataPacket }) => {
  const { data } = await axios.post(`/settings`, {
    resource,
    resource_tab,
    settings_level,
    data: dataPacket,
  });
  return data;
};

const getSetting = async (url, panelName) => {
  try {
    const { data } = await axios.get(`/${url}/${panelName}`);
    console.log(data, "data");
    return data;
  } catch (e) {
    return null;
  }
}

const getSettingByResource = async (resource, resource_tab) => {
  try {
    const { data } = await axios.get(`/settings/${resource}/${resource_tab}`);
    return data;
  } catch (e) {
    return null;
  }
}

const updateSettings = async ({ data: dataPacket, id }) => {
  console.log("!", dataPacket, "data", id);
  try {
    const { data } = await axios.put(`/settings/${id}`, { data: dataPacket });
    return data;
  } catch (e) {
    throw e;
  }
};

export { updateSettings, getSettingByResource, getSetting, addNewSetting };